export default {"src":"/_next/static/media/icon.1010dad1.svg","height":934,"width":921,"blurWidth":0,"blurHeight":0};